import { AccountType } from "@common/constants/domains/accounting/accounts";

// Merge keys are JSON.stringify of a fixed-length array so a `|` in a name or
// code cannot collide two logically different rows.

// UNGROUPED_PARENT_IDENTITY is never a database group id.
export const UNGROUPED_PARENT_IDENTITY = "ungrouped";

interface GroupDisplayKeyParams {
    type: AccountType;
    namePath: string[];
}

export const getGroupDisplayKey = ({
    type,
    namePath,
}: GroupDisplayKeyParams): string =>
    JSON.stringify([type.toLowerCase(), ...namePath]);

interface AccountDisplayKeyParams {
    codeText: string | null;
    name: string;
    isDisabled: boolean;
    type: AccountType;
    parentGroupIdentity: string;
}

// `subtype` is not in the key.
export const getAccountDisplayKey = ({
    codeText,
    name,
    isDisabled,
    type,
    parentGroupIdentity,
}: AccountDisplayKeyParams): string =>
    JSON.stringify([
        codeText ?? "",
        name,
        isDisabled,
        type,
        parentGroupIdentity,
    ]);
